import { downloadLinks } from '@/mocks/data';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[640px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20vibrant%20and%20energetic%20abstract%20background%20with%20flowing%20gradient%20waves%20in%20warm%20orange%20and%20fresh%20green%20tones%2C%20modern%20minimalist%20design%2C%20smooth%20curves%20and%20geometric%20shapes%2C%20digital%20tech%20vibe%2C%20bright%20and%20uplifting%20atmosphere%2C%20clean%20composition%20with%20soft%20gradients&width=1800&height=800&seq=hero-bg-2026&orientation=landscape"
          alt="黄瓜视频App - 记录美好，分享快乐"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/45"></div>

      <div className="relative z-10 w-full max-w-[900px] mx-auto px-4 md:px-6 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/15 backdrop-blur-sm border border-white/20 mb-6">
          <div className="w-2 h-2 rounded-full bg-accent-400"></div>
          <span className="text-xs md:text-sm text-background-50/90">v5.8.0 全新版本 · AI创作助手现已上线</span>
        </div>

        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 mb-4 leading-tight">
          黄瓜视频App
        </h1>

        <p className="text-lg md:text-xl text-background-50/80 mb-3 font-heading">
          记录美好，分享快乐
        </p>

        <p className="text-sm md:text-base text-background-50/70 max-w-[600px] mx-auto mb-8 leading-relaxed">
          海量原创短视频内容，简洁流畅的观看体验。智能推荐算法，精准匹配你的兴趣。下载黄瓜视频App，发现属于你的精彩世界。
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href={downloadLinks.ios}
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-background-50 text-foreground-900 rounded-full font-medium text-sm hover:bg-background-100 transition-all duration-200 cursor-pointer whitespace-nowrap"
            target="_blank"
            rel="noopener noreferrer"
          >
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-apple-fill text-lg"></i>
            </div>
            iOS版下载
          </a>
          <a
            href={downloadLinks.android}
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-primary-500 text-background-50 rounded-full font-medium text-sm hover:bg-primary-600 transition-all duration-200 cursor-pointer whitespace-nowrap"
            target="_blank"
            rel="noopener noreferrer"
          >
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-android-fill text-lg"></i>
            </div>
            Android版下载
          </a>
        </div>

        <div className="flex items-center justify-center gap-6 mt-8">
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold text-background-50">{'>'}5000万</p>
            <p className="text-xs text-background-50/60 mt-0.5">累计用户</p>
          </div>
          <div className="w-px h-10 bg-background-50/20"></div>
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold text-background-50">4.9</p>
            <p className="text-xs text-background-50/60 mt-0.5">用户评分</p>
          </div>
          <div className="w-px h-10 bg-background-50/20"></div>
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold text-background-50">10万+</p>
            <p className="text-xs text-background-50/60 mt-0.5">创作者</p>
          </div>
        </div>
      </div>
    </section>
  );
}